import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "legal-warning" }
const _hoisted_2 = {
  key: 0,
  class: "legal-warning__popup-container"
}
const _hoisted_3 = { class: "legal-warning__popup" }

import { onMounted, ref, watch } from "vue";
import { LegalWarningAnalytics } from "@/shared/utils/analytics/analytics-legal-warning";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { useLocalStorage, useSessionStorage } from "@sazka/utils/use-storage";
import TransitionFade from "@sazka/design-system/src/transitions/transition-fade.vue";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import { usePopupsSequence } from "@/shared/components/master-page/use-popups-sequence";

const POPUP_CLOSED_KEY = "legalWarningClosed";
const POPUP_TIME_VISIBLE = 2800;


export default /*@__PURE__*/_defineComponent({
  __name: 'legal-warning',
  setup(__props) {

const { getItem, setItem } = useSessionStorage();
const { isLegalWarningVisible, isLegalWarningClosed } = usePopupsSequence();

const closeLegalWarningModal = () => {
    isLegalWarningClosed.value = true;
    isLegalWarningVisible.value = false;
    setItem(POPUP_CLOSED_KEY, "true", "essential");
};

const openLegalWarningModal = () => {
    isLegalWarningVisible.value = true;
};

const handleClickClose = () => {
    closeLegalWarningModal();
    LegalWarningAnalytics.closePopupScreen();
};

watch(isLegalWarningVisible, (newValue) => {
    if (newValue) {
        setTimeout(() => {
            closeLegalWarningModal();
        }, POPUP_TIME_VISIBLE);
    }
});

const isProd = environment.env === "Production";
const blockPopup = ref(false);
if (!isProd) {
    const blockItem = useLocalStorage().getItem("devBlockLegalWarning");
    blockPopup.value = blockItem === "true";
}

const keyDownEventHandler = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
        e.preventDefault();
        e.stopImmediatePropagation();
        closeLegalWarningModal();
    }
};

onMounted(() => {
    if (blockPopup.value) return;

    const modalClosed = getItem(POPUP_CLOSED_KEY);
    if (modalClosed === "true") return;

    openLegalWarningModal();
    LegalWarningAnalytics.openPopupScreen();
    document.addEventListener("keydown", keyDownEventHandler, { once: true });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TransitionFade, null, {
      default: _withCtx(() => [
        (_unref(isLegalWarningVisible))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: handleClickClose,
              class: "legal-warning__overlay"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-up" }, {
      default: _withCtx(() => [
        (_unref(isLegalWarningVisible))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(WebpImage, {
                  class: "legal-warning__picture",
                  "css-class": "legal-warning__img",
                  src: "/frontend/web/img/homepage/legal-warning/18plus.svg",
                  alt: "18+"
                }),
                _cache[0] || (_cache[0] = _createElementVNode("p", { class: "legal-warning__text" }, " Zákaz účasti na hazardní hře osobám mladších 18 let. | Účast na hazardní hře může být škodlivá. ", -1)),
                _createElementVNode("button", {
                  class: "legal-warning__close",
                  onClick: handleClickClose
                }, [
                  _createVNode(DsIcon, {
                    class: "legal-warning__close-icon",
                    name: "close",
                    width: 12,
                    height: 12
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})